// Runtime configuration that can be overridden by environment variables at deployment time

declare global {
  interface Window {
    _env_?: {
      VITE_API_BASE_URL?: string
      VITE_ENVIRONMENT?: string
      VITE_ENABLE_MOCKS?: string
    }
  }
}

function getConfigValue(key: string, defaultValue?: string): string {
  // First try runtime environment (injected by docker-entrypoint.sh)
  const runtimeValue = window._env_?.[key as keyof typeof window._env_]
  if (runtimeValue) {
    return runtimeValue
  }

  // Special handling for API URL based on hostname
  if (key === 'VITE_API_BASE_URL') {
    const hostname = typeof window !== 'undefined' ? window.location.hostname : ''

    // If using local development domains, use local API domain for proper cookie handling
    if (hostname === 'local.provider.determa.co') {
      return 'http://local.api.determa.co:8000'
    }
  }

  // Test environment - use defaults
  if (typeof process !== 'undefined' && process.env.NODE_ENV === 'test') {
    return defaultValue || (key === 'VITE_API_BASE_URL' ? 'http://localhost:8000' : 'development')
  }

  // Production/Development browser environment - use process.env (set by Vite)
  if (typeof process !== 'undefined' && process.env) {
    switch (key) {
      case 'VITE_API_BASE_URL':
        return process.env.VITE_API_BASE_URL || defaultValue || 'http://localhost:8000'
      case 'VITE_ENVIRONMENT':
        return process.env.VITE_ENVIRONMENT || defaultValue || 'development'
      case 'VITE_ENABLE_MOCKS':
        return process.env.VITE_ENABLE_MOCKS || defaultValue || ''
      default:
        return defaultValue || ''
    }
  }

  // Final fallback
  return defaultValue || (key === 'VITE_API_BASE_URL' ? 'http://localhost:8000' : 'development')
}

export const config = {
  apiBaseUrl: getConfigValue('VITE_API_BASE_URL', 'http://localhost:8000'),
  environment: getConfigValue('VITE_ENVIRONMENT', 'development'),
  isDevelopment: getConfigValue('VITE_ENVIRONMENT', 'development') === 'development',
  isProduction: getConfigValue('VITE_ENVIRONMENT', 'development') === 'production',
  enableMocks: getConfigValue('VITE_ENVIRONMENT', 'development') === 'development' || !!(getConfigValue('VITE_ENABLE_MOCKS', '')),
} as const

if (config.isDevelopment && typeof process !== 'undefined' && process.env.NODE_ENV !== 'test') {
  console.log('Provider Portal Configuration:', config)
}
